import { Stack } from "expo-router";
import { useTranslation } from "react-i18next";

import { ActiveSessionsScreen } from "@/features/menu/settings/ActiveSessionsScreen";

export default function ActiveSessions() {
    const { t } = useTranslation();

    return (
        <>
            <Stack.Screen options={{ title: t("activeSessions.title") }} />
            <ActiveSessionsScreen />
        </>
    );
}
